export default "__VITE_ASSET__CzBuJy3j__"